import { useState } from 'react';
import { ArticleCard } from '../../../../components/ArticleCard/ArticleCard';
import { Loader } from '../../../../components/Loader/Loader';
import { useFetchArticles } from '../../../../hooks/useFetchArticles';
import Pagination from '../../SupportList/Pagination';
import styles from './ArticleList.module.scss';

export const ArticleList = () => {
    const [page, setPage] = useState<number>(1);
    const { articles, pageCount, isLoading } = useFetchArticles(page, 12);

    return (
        <div className={styles.list}>
            {isLoading ? <Loader /> : null}

            {!isLoading && articles?.length === 0 ? (
                <span className={styles.list__empty}>Материалов пока нет!</span>
            ) : null}

            <div className={styles.list__cards}>
                {!isLoading &&
                    articles?.map((article) => (
                        <ArticleCard key={article.id} article={article} />
                    ))}
            </div>

            <Pagination
                list={{ page_count: pageCount, current_page: page }}
                handlePagination={setPage}
                isLoading={isLoading}
            />
        </div>
    );
};
